import { io, Socket } from 'socket.io-client';
import type { AdminServerEvents } from '@scan2eat/shared';
import { SOCKET_NAMESPACES } from '@scan2eat/shared';

export type AdminSocket = Socket<AdminServerEvents>;

let socket: AdminSocket | null = null;

export function connectAdminSocket(accessToken: string): AdminSocket {
  if (socket?.connected) return socket;

  const baseUrl = import.meta.env.VITE_API_URL?.replace(/\/api\/?$/, '') ?? '';
  socket = io(`${baseUrl}${SOCKET_NAMESPACES.ADMIN}`, {
    auth: { accessToken },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: Infinity,
    timeout: 10000,
  });

  return socket;
}

/**
 * Instance courante, sans en ouvrir une.
 *
 * Pour les composants qui veulent ecouter le canal admin sans en gerer le
 * cycle de vie : la barre de navigation vit sur toutes les pages, alors que
 * c'est la page affichee qui ouvre et ferme la connexion.
 */
export function getAdminSocket(): AdminSocket | null {
  return socket;
}

export function reconnectAdminSocket(accessToken: string): AdminSocket {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  return connectAdminSocket(accessToken);
}

export function disconnectAdminSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
